// extracted by mini-css-extract-plugin
module.exports = {"container":"Upload_container__2xiV6","transitionBoundary":"Upload_transitionBoundary__2Buzp"};